import { styled } from '@mui/material';

/**
 * The natalie-templates details-dialog lockup: a 56px rounded tile with a faint rim, in the warning (yellow)
 * family while answering and the success (green) family once `data-done` is set; the colours crossfade on
 * `--motion-surface`. Hidden on phones; the breakpoint lives here, not in a Tailwind `max-sm:hidden`, because
 * Tailwind utilities sit in a cascade layer and lose to this unlayered `display`.
 */
export const IconTile = styled('span')({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: 'var(--radius-md)',
  borderWidth: 1,
  borderStyle: 'solid',
  color: 'var(--background-warning-active)',
  background: 'color-mix(in oklab, var(--background-warning-muted) 60%, var(--background-primary))',
  borderColor: 'color-mix(in oklab, var(--background-warning) 45%, var(--background-primary))',
  boxShadow: '0 1px 1px color-mix(in oklab, var(--neutral-950) 4%, transparent)',
  transitionProperty: 'background-color, border-color, color',
  transitionDuration: 'var(--motion-surface)',
  transitionTimingFunction: 'var(--motion-surface-ease)',
  '&[data-done]': {
    color: 'var(--foreground-success)',
    background: 'color-mix(in oklab, var(--background-success-muted) 60%, var(--background-primary))',
    borderColor: 'color-mix(in oklab, var(--background-success) 35%, var(--background-primary))',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
  // Tailwind's `max-sm` (below 40rem), not MUI's 600px `sm`.
  '@media (width < 40rem)': {
    display: 'none',
  },
});

/** The check pops in on the thank-you. */
export const Pop = styled('span')({
  display: 'flex',
  '@keyframes formsHeaderPop': {
    from: { opacity: 0, transform: 'scale(0.6)' },
    to: { opacity: 1, transform: 'none' },
  },
  '&[data-animate]': {
    animation: 'formsHeaderPop 260ms var(--ease-entrance) both',
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none !important',
  },
});

/** The thank-you title block rises in. */
export const Rise = styled('div')({
  '@keyframes formsHeaderRise': {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'none' },
  },
  '&[data-animate]': {
    animation: 'formsHeaderRise 380ms cubic-bezier(0.32, 0.72, 0, 1) both',
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none !important',
  },
});
